/* api/index.js */ function _(require, module, exports) {
    function __export(m) {
        for (var p in m)
            if (!exports.hasOwnProperty(p))
                exports[p] = m[p];
    }
    const LinAlg = require(363) /* ./linalg */;
    exports.LinAlg = LinAlg;
    const Charts = require(365) /* ./charts */;
    exports.Charts = Charts;
    const Plotting = require(368) /* ./plotting */;
    exports.Plotting = Plotting;
    var document_1 = require(4) /* ../document */;
    exports.Document = document_1.Document;
    var templating_1 = require(151) /* ../core/util/templating */;
    exports.sprintf = templating_1.sprintf;
    __export(require(367) /* ./models */);
}
